/**
 * 🎄 TEMA DE NATAL PREMIUM - JS OTIMIZADO
 * Foco em performance e UX limpa
 */

(function() {
  'use strict';

  // Configuração Minimalista
  const CONFIG = {
    snowflakeCount: 15, // Menos é mais (elegância)
  };

  /**
   * Cria partículas de neve (Bokeh Effect)
   */
  function createSnowflakes() {
    if (document.querySelector('.christmas-snowflakes')) return;

    const container = document.createElement('div');
    container.className = 'christmas-snowflakes';
    container.setAttribute('aria-hidden', 'true');

    for (let i = 0; i < CONFIG.snowflakeCount; i++) {
      const snowflake = document.createElement('div');
      snowflake.className = 'snowflake';
      container.appendChild(snowflake);
    }

    document.body.appendChild(container);
  }

  /**
   * Adiciona badge sutil no carrinho
   */
  function addChristmasCartIcon() {
    const cartIcon = document.querySelector('.icon-cart, [href*="cart"]');
    if (cartIcon && !cartIcon.querySelector('.christmas-cart-badge')) {
      // Pequeno ponto vermelho de notificação (estilo iOS/App)
      const badge = document.createElement('span');
      badge.className = 'christmas-cart-badge';
      badge.style.cssText = `
        position: absolute;
        top: -2px;
        right: -2px;
        width: 8px;
        height: 8px;
        background-color: var(--christmas-red-primary);
        border-radius: 50%;
        border: 1px solid white;
        pointer-events: none;
      `;
      
      const parent = cartIcon.parentElement;
      if (parent) {
        parent.style.position = 'relative';
        parent.appendChild(badge);
      }
    }
  }

  /**
   * Inicialização
   */
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }
    
    createSnowflakes();
    addChristmasCartIcon();
    console.log('🎄 Premium Christmas Theme Active');
  }

  init();
})();
